import createCachedSelector from 're-reselect'

import selectIntegrationCredentialsById from './selectIntegrationCredentialsById'

export default createCachedSelector(
  selectIntegrationCredentialsById,
  (state, { id }) => id,
  (integrationCredentials, id) => {
    const forId = integrationCredentials[id]
    if (forId) return forId
    return undefined
  }
)((state, { id }) => id)
